import { combineReducers } from 'redux'

import search from './search'
import cart from './cart'
import checkout from './checkout'
import adminUser from './admin/admin-user'
import adminOrders from './admin/admin-orders'
import salesToken from './salesToken'

export default combineReducers({
  search,
  cart,
  checkout,
  adminUser,
  adminOrders,
  salesToken
})
